// eslint-disable-next-line no-undef
const { __, sprintf } = wp.i18n

import { isWithinDate } from '../utiils'

const checkStringMatch = (originalString, checkString) => {
  if (!originalString) return false
  return checkString.startsWith(originalString)
}

const productHit = (item, classes = 'g-col-12 g-col-lg-6 g-col-xl-4') => {
  const {
    iso8601,
    url,
    inPromotion,
    title,
    images,
    productTypes,
    labels,
    codeArticle,
  } = item

  const shouldHighlight = checkStringMatch(
    item._highlightResult.codeArticle?.matchedWords[0],
    codeArticle
  )

  let orientation = 'horizontal'
  if (images.height && images.width && images.height - images.width >= 100) {
    orientation = 'vertical'
  }

  return `
    <article class="feed-product ${classes}${
      images.base ? ' has-post-thumbnail' : ''
    }">
        <a href="${url}" class="feed-product__wrapper">
            <div class="feed-product__top">
                ${
                  isWithinDate(iso8601)
                    ? `
                    <span class="icon-badge icon-badge--primary">
                        <span class="vn-a-icon"><i class="vn-icons-drap-star"></i></span>
                        <span class="vn-a-content">${__('New!', 'vn')}</span>
                    </span>
                `
                    : ''
                }
               ${
                 inPromotion
                   ? `
                    <span class="icon-badge icon-badge--secondary">
                        <span class="vn-a-icon"><i class="vn-icons-drap-info"></i></span>
                        <span class="vn-a-content">${__(
                          'Promotion!',
                          'vn'
                        )}</span>
                    </span>
                `
                   : ''
               }
            </div>
            
            <div class="feed-product__middle">
                ${
                  images.base
                    ? `<img src="${images.base}" alt="${title}" class="feed-product__thumbnail ${orientation}" />`
                    : ''
                }
            </div>
            
            <div class="feed-product__bottom">
                ${
                  productTypes.length
                    ? `
                <div class="feed-product__types">
                  ${productTypes.map((productType) => {
                    let res
                    productType.images && productType.images.thumbnail
                      ? (res = `<span class="feed-product__with-image-icon"><span class="vn-a-icon"><img decoding="async" src="${productType.images.thumbnail}" class="inject-this feed-product__icon" alt="${productType.name}"></span>${productType.name}</span>`)
                      : (res = `<span>${productType.name}</span>`)
                    return res
                  })}
                </div>
                `
                    : ''
                }
                
                <span class="feed-product__title">${
                  item._highlightResult.title.value
                }</span>
                
                <div class="feed-product__footer">
                  <span class="feed-product__ref">${sprintf(
                    __('Ref: %s', 'vn'),
                    shouldHighlight
                      ? item._highlightResult.codeArticle.value
                      : codeArticle
                  )}</span>
                  
                  ${
                    labels.length
                      ? `
                  <div class="feed-product__label-images">
                    ${labels.map((label) => {
                      return label.image.url
                        ? `<img src="${label.image.url}" alt="${title}" />`
                        : ''
                    })}
                  </div>
                  `
                      : ''
                  }
                </div>  
            </div>
        </a>
    </article>
  `
}
const productButtun = {}
productButtun.textContent = __('Load more products', 'vn')

export { productHit, productButtun }
